import { useForm } from '@mantine/form';

import { CA_STATES, COUNTRY_CODES, CURRENCIES, US_STATES } from '../config';
import { UploadAnonDataPayload } from '../types';
import { isOneOf } from '../utils';

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const useDataUploadForm = () =>
  useForm<UploadAnonDataPayload>({
    initialValues: {
      company_id: '',
      currency: '',
      annual_revenue: '',
      country: '',
      incorporation_date: null,
      client_onboarding_date: null,
      state: '',
    },
    validate: {
      currency: (value: string) => {
        if (!value) return 'Currency is required';
        if (!isOneOf(value, CURRENCIES)) return 'Unsupported currency';

        return null;
      },
      annual_revenue: (value) => (!value ? 'Annual Revenue is required' : null),
      country: (value) => {
        if (!value) return 'Country is required';
        if (!isOneOf(value, COUNTRY_CODES)) return 'Unsupported country';

        return null;
      },
      incorporation_date: (value) => {
        if (value && !dateRegex.test(value)) {
          return 'Date must be in format yyyy-mm-dd';
        }

        return null;
      },
      client_onboarding_date: (value) => {
        if (value && !dateRegex.test(value)) {
          return 'Date must be in format yyyy-mm-dd';
        }

        return null;
      },
      state: (value, values) => {
        if (values.country === 'US') {
          if (!value) return 'State is required for US';
          if (!isOneOf(value, US_STATES)) {
            return 'Unsupported US state';
          }
        } else if (values.country === 'CA') {
          if (!value) return 'Province is required for CA';
          if (!isOneOf(value, CA_STATES)) {
            return 'Unsupported CA province';
          }
        }

        return null;
      },
    },
  });
